
import SideMenu from './MainLayout';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';

const Layout = () => {

    const [expanded, setExpanded] = useState(true);

    return (
        <div className="layout">
            <SideMenu setExpandedState={setExpanded} />
            <div className="main-content" style={{ marginLeft: expanded ? 260 : 72, transition: 'margin-left 0.25s ease' }}>
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;